import {ChangeDetectorRef, Component, Inject, OnInit} from '@angular/core';
import {AbstractControl, FormGroup} from '@angular/forms';
import {Culture, Service, SEPARATOR_SELECT, Timezone} from '../../..';
import {Observable, Subscription} from 'rxjs';
import {Config} from '../../../models/config';
import {Country} from '../../../models/country';
import {Product} from '../../../models/product';
import {Device} from '../../../models/device';
import {ServerForm, ServerFormUrl} from '../../../models/servers';
import {SimpleObject} from '../../../models/simple-object';
import {UpdateDynamicFormService} from '../../../services/update-dynamic-form.service';
import {L10N_LOCALE, L10nLocale} from 'angular-l10n';

@Component({
  selector: 'storever-form-select',
  templateUrl: './form-select.component.html',
  styleUrls: ['./form-select.component.scss']
})
export class FormSelectComponent  implements OnInit {
  config: Config;
  group: FormGroup;
  datas: Observable<Timezone[] | Culture[] | Country[] | Product[] | Device[] | Service[] | ServerForm[]  | ServerFormUrl [] | SimpleObject[] | string[]>;
  isEdit: boolean;
  separator = SEPARATOR_SELECT;
  controlName = null;
  showWarning: boolean;
  toggleElements = true;
  private sub$: Subscription;
  private subscriptions = [];

  get isEnabled(): boolean {
    return this.group.disabled;
  }

  constructor(@Inject(L10N_LOCALE) public locale: L10nLocale, private updateDynamicFormService: UpdateDynamicFormService,
              private cdr: ChangeDetectorRef) {
    this.updateStatus();
  }

  ngOnInit(): void {
    if (this.config && this.config.options) {
      if (this.config.options.toggle === false && this.config.options.toggle !== undefined) {
        this.toggleElements = false;
      }
      if (this.config.options.toggle === undefined) {
        this.toggleElements = true;
      }
    }
  }
  /**
   * cette fonction update le bon boolean pour le bon contrôleur et pour le bon type
   * Actuellement il n'y a que deux types le triangle de warning et type toggle qui permet de cacher/afficher un element
   * @param le nom du controller actuelle
   *
   */
  getStatus(name: string): void {
      const warningStatus = this.updateDynamicFormService.status(name);
      if (warningStatus) {
        this.controlName = warningStatus.controlName;
        if (name === this.controlName) {
          if ( warningStatus.type === 'warning') {
            this.showWarning =  warningStatus.status;
            this.cdr.markForCheck();
          } else if ( warningStatus.type === 'toggle') {
            this.toggleElements =  warningStatus.status;
            this.cdr.markForCheck();
          }
          } else {
          this.showWarning = false;
        }

      }
  }
  get getControlName(): AbstractControl {
    return this.group.get(this.config.controlName[0]);
  }
  get getControlNameSub(): AbstractControl {
    return this.group.get(this.config.controlName[0]);
  }
  updateStatus(): void {
    this.sub$ = this.updateDynamicFormService.getResponse().subscribe((data) => {
      if (data && this.config) {
        this.getStatus(this.config.controlName[0]);
      }
    });
    this.subscriptions.push(this.sub$);
  }
}
